export default "__VITE_ASSET__2CWFNQcZ__"